(function () {
    var ratings = null;

    function load() {
        if (ratings) return ratings;
        var source = document.querySelector('[data-pv-ratings]');
        try {
            ratings = source ? JSON.parse(source.textContent) : {};
        } catch (error) {
            ratings = {};
        }
        return ratings;
    }

    window.pvRating = {
        get: function (handle) {
            var item = load()[handle];
            return item && item.count > 0 ? item : null;
        },
        countLabel: function (item) {
            return item ? item.count + (item.count === 1 ? ' review' : ' reviews') : '';
        },
    };
})();
